exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideout-shopping-basket h2[data-v-362c3a3a]{font-weight:900;font-size:1.25rem;line-height:1.625rem}@media screen and (min-width:1024px){.slideout-shopping-basket h2[data-v-362c3a3a]{font-size:1.5rem;line-height:2.3125rem}}", ""]);

// exports
